
export const ADD_PROFILE_DETAILS = 'ADD_PROFILE_DETAILS'
export const ADD_PROFILE_IMAGE = 'ADD_PROFILE_IMAGE'
export const ADD_APPLICATION_LOGO = 'ADD_APPLICATION_LOGO'
export const SET_CURRENT_PRODUCT_UUID = 'SET_CURRENT_PRODUCT_UUID'
export const USER_ID = 'USER_ID'
export const ACCESS = 'ACCESS'

export const profileImages = (payload: any) => (console.log(payload, "payload"), {
  type: ADD_PROFILE_IMAGE,
  payload: payload,
});
export const Logo = (payload: any) => (console.log(payload, "payload"), {
  type: ADD_APPLICATION_LOGO,
  payload: payload,
});
export const profileSettings = (payload: any) => ({
  type: ADD_PROFILE_DETAILS,
  payload: payload,
});
export const currentProductUuid = (payload: any) => ({
  type: SET_CURRENT_PRODUCT_UUID,
  payload: payload,
});
export const SetUserId = (payload: any) => ({
  type: USER_ID,
  payload: payload
})
export const Access = (payload: any) => ({
  type: ACCESS,
  payload: payload
})